import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import declare from "dojo/_base/declare";

const NodeNameStringRenderer = declare(StringRen, {
	/**
	 * @override
	 * Display node names as a string instead of a ref
	 */
	toValue(ctx: Context, h: Heading): string {
		return ctx.getNode().$Name;
	},

	reserveContext(ctx: Context, h: Heading): void {
		h.m_link = null;
		this.inherited(arguments);
	},

});

export = NodeNameStringRenderer;